import { useQuery } from '@tanstack/react-query';
import { recurrentApplicationsGetAllOfPublisher } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useRecurrentApplications = (publisherId?: number) =>
  useQuery({
    queryFn: () =>
      extractData(
        recurrentApplicationsGetAllOfPublisher({
          path: { publisherId: publisherId! },
        })
      ),
    queryKey: ['recurrentApplications', publisherId],
    enabled: Boolean(publisherId),
  });
